import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { LoadAllContact, UpdateContact } from '../../../../actions/ActivitesPages/ManagerPageAction';
import { baseUrl } from '../../../../nametitle/dataUrl';
import { Localvalue } from '../../../../nametitle/localValue';
import { getDataFromFile } from '../../../../actions/SearchAction';

const FormSubscribe = () => {
    const [reading, setreading] = useState(true);
    const [id, setid] = useState();

    const [coverPicture, setcoverPicture] = useState();
    const [logo, setlogo] = useState();
    const [name, setname] = useState();
    const [email, setemail] = useState();
    const [telephone1, settelephone1] = useState();
    const [telephone2, settelephone2] = useState();
    const [telephone3, settelephone3] = useState();

    const [facebook, setfacebook] = useState();
    const [youtube, setyoutube] = useState();
    const [instagram, setinstagram] = useState();



    const [Loading, setLoading] = useState();

    useEffect(() => {
        const object = getDataFromFile(Localvalue.activitePageData);
        setlogo(object && object.contact && object.contact.activite1 && object.contact.activite1.logo ? object.contact.activite1.logo : "");
        setname(object && object.contact && object.contact.activite1 && object.contact.activite1.name ? object.contact.activite1.name : "");
        setcoverPicture(object && object.contact && object.contact.activite1 && object.contact.activite1.coverPicture ? object.contact.activite1.coverPicture : "");
        // ***************************************************     Activté 3
        setemail(object && object.contact && object.contact.activite2 && object.contact.activite2.email ? object.contact.activite2.email : "");
        settelephone1(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone1 ? object.contact.activite2.telephone1 : "");
        settelephone2(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone2 ? object.contact.activite2.telephone2 : "");
        settelephone3(object && object.contact && object.contact.activite2 && object.contact.activite2.telephone3 ? object.contact.activite2.telephone3 : "");
        // ***************************************************     Activté 3
        setfacebook(object && object.contact && object.contact.activite3 && object.contact.activite3.facebook ? object.contact.activite3.facebook : "");
        setyoutube(object && object.contact && object.contact.activite3 && object.contact.activite3.youtube ? object.contact.activite3.youtube : "");
        setinstagram(object && object.contact && object.contact.activite3 && object.contact.activite3.instagram ? object.contact.activite3.instagram : "");
        LoadAllContact(setid, setlogo, setname, setcoverPicture,
            setemail, settelephone1, settelephone2, settelephone3,
            setfacebook, setyoutube, setinstagram)
    }, []);
    function ReadChamp() {
        setreading(!reading)
    }

    // Upload des fichier 
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
            fileReader.onerror = (error) => { reject(error); };
        });
    };




    // Image 1
    function uploadSingleLogo(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setlogo(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadLogo = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleLogo(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };



    // Image 2
    function uploadSingleImage(base64) {
        setLoading(true);
        axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
            .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
            .then(() => setLoading(false))
            .catch(console.log);
    }
    const uploadImage = async (event) => {
        const files = event.target.files;
        console.log(files.length);
        if (files.length === 1) {
            const base64 = await convertBase64(files[0]);
            uploadSingleImage(base64); return;
        }
        const base64s = [];
        for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
    };





    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();

                UpdateContact(id, logo, name, coverPicture, email, telephone1, telephone2, telephone3, facebook, youtube, instagram
                )
            }}
        >
            <h2 className="translatable text-2xl py-2 bg-light">Page a propos de nous ? </h2>


            <div className="translatable input-group mb-3 flex flex-row space-x-5">
                <input onChange={ReadChamp} type="checkbox" className="translatable h-[30px] w-[30px]" />
                <label>rendre les champ disponible </label>
            </div>
            <div className="translatable bg-info my-3">
                <h2>activté 1</h2>
            </div>

            <div className="translatable border-green-400 p-3">
                {logo && (<img src={`${logo}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">logo</span>
                    <input onChange={uploadLogo} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                {coverPicture && (<img src={`${coverPicture}`} className="translatable h-[100px] w-[100px]" />)}
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">Image entrep</span>
                    <input onChange={uploadImage} readOnly={reading} type="file" className="translatable form-control" accept=".JPG , PNG, JPEG" placeholder="" aria-label="" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">nom de l{"'"}entreprise</span>
                    <input readOnly={reading} value={name} onChange={(e) => { setname(e.target.value) }} type="text" className="translatable form-control" placeholder=" nom de l'entreprise" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable bg-info my-3">
                <h2>activté 2</h2>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">email</span>
                    <input readOnly={reading} value={email} onChange={(e) => { setemail(e.target.value) }} type="text" className="translatable form-control" placeholder=" email" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">téléphone 1</span>
                    <input readOnly={reading} value={telephone1} onChange={(e) => { settelephone1(e.target.value) }} type="text" className="translatable form-control" placeholder=" téléphone 1" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">téléhpone 2</span>
                    <input readOnly={reading} value={telephone2} onChange={(e) => { settelephone2(e.target.value) }} type="text" className="translatable form-control" placeholder=" téléphone 2" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">téléphone 3</span>
                    <input readOnly={reading} value={telephone3} onChange={(e) => { settelephone3(e.target.value) }} type="text" className="translatable form-control" placeholder=" téléphone 3" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>

            <div className="translatable bg-info my-3">
                <h2>activté 3</h2>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">lien facebook</span>
                    <input readOnly={reading} value={facebook} onChange={(e) => { setfacebook(e.target.value) }} type="text" className="translatable form-control" placeholder=" facebook" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">lien youtube</span>
                    <input readOnly={reading} value={youtube} onChange={(e) => { setyoutube(e.target.value) }} type="text" className="translatable form-control" placeholder=" youtube" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable border-green-400 p-3">
                <div className="translatable input-group mb-3">
                    <span className="translatable input-group-text" id="basic-addon1">lien instagram</span>
                    <input readOnly={reading} value={instagram} onChange={(e) => { setinstagram(e.target.value) }} type="text" className="translatable form-control" placeholder=" instagram" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
            </div>
            <div className="translatable  mb-3 mt-5">
                <button type="submit" className="translatable btn bg-gray-900 btn-dark py-3 px-2">Enregistrer changement </button>
            </div>

        </form>
    )
}

export default FormSubscribe;